import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { map } from 'rxjs/operators';
import { environment } from '../../../../environments/environment';
import { AccumulativeReportBuilder } from '../../models/builder/accumulative-report.builder';
import { AverageReportBuilder } from '../../models/builder/average-report.builder';
import { CompanyBuilder } from '../../models/builder/company.builder';
import { FilteredPollGroupsBuilder } from '../../models/builder/filtered-poll-groups.builder';
import { EvolutionReportBuilder } from '../../models/builder/evolution-report.builder';
import { PollGroupBuilder } from '../../models/builder/poll-group.builder';
import { PollGroupsRequestInterface } from '../../models/request/poll-groups-request.interface';
import { PollBuilder } from '../../models/builder/poll.builder';
import { UniqueReportBuilder } from '../../models/builder/unique-report.builder';

@Injectable()
export class CompanyApiService {
  private apiUrl: string;

  constructor(
    private httpClient: HttpClient,
  ) {
    this.apiUrl = `${environment.companyAdmin.apiUrl}companies`;
  }

  getCompany() {
    return this.httpClient.get(`${this.apiUrl}`)
      .pipe(map(CompanyBuilder.fromJson));
  }

  getFilteredCompanyPollGroups(query, request: PollGroupsRequestInterface) {
    let params = new HttpParams();
    params = params.append('query', query ? query.toLowerCase() : '')
      .append('page', request.page.toString())
      .append('itemsPerPage', request.itemsPerPage.toString())
      .append('sortField', request.sortField)
      .append('reversed', (!!request.reversed).toString());

    return this.httpClient.get(`${this.apiUrl}/filter-poll-groups`, { params: params })
      .pipe(map(FilteredPollGroupsBuilder.fromJson));
  }

  getCompanyPollGroups() {
    return this.httpClient.get(`${this.apiUrl}/poll-groups`)
      .pipe(map(PollGroupBuilder.fromList));
  }

  searchCompanyPollGroups(query: string) {
    const params = new HttpParams().append('query', query ? query.toLowerCase() : '');

    return this.httpClient.get(`${this.apiUrl}/search/options`, { params })
      .pipe(
        map(PollGroupBuilder.fromList)
      );
  }

  getCompanyPolls() {
    return this.httpClient.get(`${this.apiUrl}/polls`)
      .pipe(map(PollBuilder.fromList));
  }

  getUniqueReport(hash: string) {
    const params = new HttpParams().append('pollHash', hash ? hash : '');

    return this.httpClient.get(`${this.apiUrl}/unique-reports`, { params })
      .pipe(map(UniqueReportBuilder.fromList));
  }

  getAccumulativeReport(pollHashes) {
    const params = new HttpParams().append('pollHashes', pollHashes ? pollHashes : '');

    return this.httpClient.get(`${this.apiUrl}/accumulative-reports`, { params })
      .pipe(map(AccumulativeReportBuilder.fromList));
  }

  getAverageReports(filterBody) {
    const params = new HttpParams().append('pollHash', filterBody ? filterBody.pollHash : '')
      .append('sectorHash', filterBody ? filterBody.sectorHash : '');

    return this.httpClient.get(`${this.apiUrl}/average-reports`, { params })
      .pipe(map(AverageReportBuilder.fromJson));
  }

  getEvolutionReports(pollGroupHash) {
    const params = new HttpParams().append('pollGroupHash', pollGroupHash ? pollGroupHash : '');

    return this.httpClient.get(`${this.apiUrl}/evolution-reports`, { params })
      .pipe(map(EvolutionReportBuilder.fromList));
  }

}
